import { Component, OnInit, Inject, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FilestackService } from '@filestack/angular';
import { ClientOptions, Security } from 'filestack-js';

import { AppSettingsService } from 'src/app/services/app-settings.service';
import { StorageObjectReqRes } from '../../models/StorageObjectReqRes.model';
import MetaFileLink, { MediaType } from 'src/app/models/metaFileLink.model';
import { TerraUtils } from '../../TerraUtils';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'terra-file-preview-dialog',
  templateUrl: './file-preview-dialog.component.html',
  styleUrls: ['./file-preview-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilePreviewDialogComponent implements OnInit, AfterViewInit {

  // enums
  MediaType = MediaType;

  mediaType: MediaType = null;

  get fullUrlWithCredentials() {
    return StorageObjectReqRes.getFilestackUrlWithCredentials(this.storageObject);
  }

  constructor(
    private appSettingsService: AppSettingsService,
    private filestackService: FilestackService,
    public dialogRef: MatDialogRef<FilePreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public storageObject: StorageObjectReqRes) {
    dialogRef.addPanelClass('file-preview-dialog');
  }

  ngOnInit() {
    this.mediaType = MetaFileLink.GetMediaType(this.storageObject.metaFileLink);
  }

  ngAfterViewInit(): void {
    switch (this.mediaType) {
      case MediaType.Image:
      case MediaType.Pdf:
      case MediaType.Presentation:
      case MediaType.Spreadsheet:
      case MediaType.TextDocument:
        this.fileStackPreview();
        break;
      case MediaType.Video:

        break;
      case MediaType.Audio:

        break;
    }

  }

  isAudioOrVideoSupportedForPreview(file: StorageObjectReqRes, mediaType: MediaType): boolean {
    return TerraUtils.isAudioOrVideoSupportedForPreview(file, mediaType);
  }

  download(storageObject: StorageObjectReqRes) {
    this.dialogRef.close({ download: true });
  }

  private fileStackPreview() {
    const clientOptions = {
      security: {
        policy: this.storageObject.filestackPolicy,
        signature: this.storageObject.filestackSignature
      } as Security
    } as ClientOptions;

    this.filestackService.init(this.appSettingsService.fileStackApiKey, clientOptions);

    this.filestackService.preview(this.storageObject.filestackHandle,
      {
        id: 'filePreviewFrame',
        // css: `https://cdn.filestackcontent.com/security=policy:eyJleHBpcnkiOiAxNTg4NjkwMjgwLCAiY2FsbCI6IFsicmVhZCJdLCAiaGFuZGxlIjogImxGVzU4aXFCUTRPZXVMcVR0T2xUIn0=,signature:665a6ab46af33654455aaedc9095c66adad35c7217be6bf7530e77d30ba505ec/lFW58iqBQ4OeuLqTtOlT`
      });
  }
}
